// import { storage } from "src/adapters/common-set-up/firebase";
import firebase from "firebase/compat/app";


export const downloadFile = async (fileRef) => {
    if (!fileRef) return;
    try {
        const url = await fileRef.getDownloadURL();
        const fileHandle = await window.showSaveFilePicker({
            suggestedName: fileRef.name,
        });

        var xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = async (event) => {
            var blob = xhr.response;

            const writable = await fileHandle.createWritable();
            await writable.write(blob);
            await writable.close();
        };
        xhr.open("GET", url);
        xhr.send();
    } catch (err) {
        console.log(err);
    }
};

export const checkHasFiles = async (storagePath, setFileRefs) => {
    const storage = firebase.storage();
    const fileStorageRef = storage.ref().child(storagePath);
    const res = await fileStorageRef.listAll();
    if (res.items?.length) {
        const fileRefs = [];
        for (let item of res.items) {
            const url = await item.getDownloadURL();
            const fileRef = storage.refFromURL(url);
            fileRefs.push(fileRef);
        }
        setFileRefs(fileRefs);
    }
};

export const deleteFile = async (fileRef) => {
    if (!fileRef) return;
    try {
        await fileRef.delete();
    } catch (err) {
        console.log(err);
    }
};